import { Component, inject, DestroyRef, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrimeNGModule } from '@/app/config/primeng';
import { Router, RouterModule } from '@angular/router';
import { AlarmsService } from '@/app/core/services/alarms.service';
import { OmniMqttService } from '@/app/core/mqtt/omni-mqtt.service';
import { toSignal, takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { map, catchError, switchMap, startWith } from 'rxjs/operators';
import { of, Subject } from 'rxjs';

@Component({
    selector: 'app-latest-alarms',
    standalone: true,
    imports: [CommonModule, PrimeNGModule, RouterModule],
    templateUrl: './latest-alarms.component.html',
})
export class LatestAlarmsComponent {
    private alarmsService = inject(AlarmsService);
    private mqttService = inject(OmniMqttService);
    private destroyRef = inject(DestroyRef);
    public router = inject(Router);

    private refresh$ = new Subject<void>();

    alarmsData = toSignal(
        this.refresh$.pipe(
            startWith(void 0),
            switchMap(() =>
                this.alarmsService.getAlarms({ pageSize: 5, statuses: [0] }).pipe(
                    map(res => res.data || []),
                    catchError(() => of([]))
                )
            )
        ),
        { initialValue: [] }
    );

    constructor() {
        // 收到即時告警封包時重新抓最新告警列表
        this.mqttService.alarms$
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(() => this.refresh$.next());
    }

    alarmClick = output<any>();
}
